var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    staticClass: "soli-round",
    attrs: {
      items: _vm.skillLevels,
      value: _vm.value,
      label: "Skill Level",
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      outlined: "",
      multiple: "",
      dense: "",
      rules: _vm.rules,
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }